import * as types from './types';

const suspendPosting = (postings, particularNotFree, finishReasonId, finishReasonText) => ({
  type: types.SUSPEND_POSTING,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: '/panel/api/v2/posting/suspend',
    method: 'PUT',
    particularNotFree,
    body: { postings, finishReasonId, finishReasonText }
  }
});

const resetSuspendPosting = () => ({
  type: types.RESET_SUSPEND_POSTING
});

export { suspendPosting, resetSuspendPosting };
